import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { ParticipantViewModel } from "../models/participant-view-model";
import { CreateResult } from "../models/create-result";
import { TMSinkNodesViewModel } from '../models/sink-nodes-view-model';
import { SinkNodeMappingConfigViewModel } from "../models/sinknode-mapping-config-view-model";
import { SinkNodeMappedFieldsViewModel } from '../models/sinknode-mapped-fields-view-model';
import { ParticipantMappingViewModel } from '../models/participant-mapping-view-model';
import { CustomTagParticipantLinkViewModel } from '../models/card-set-participant-link';
import { ProductProfileViewModel } from "../models/product-profile-view-model";
import { CapabilityProfileViewModel } from "../models/capability-profile-view-model";
import { TerminalViewModel } from '../models/terminal-view-model';

@Injectable({
  providedIn: 'root'
})
export class TerminalCapabilityService {

  constructor(private _httpService: HttpService) {
  }

  public async GetTerminalCapabilities(): Promise<CapabilityProfileViewModel[]> {
    const httpResult = await this._httpService.apiGet<CapabilityProfileViewModel[]>(`terminalCapability/CapabilityProfiles`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalCapabilitiesForParticipantOrAll(): Promise<CapabilityProfileViewModel[]> {
    const httpResult = await this._httpService.apiGet<CapabilityProfileViewModel[]>(`terminalCapability/CapabilityProfilesForParticipantOrAll`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalCapabilitiesByParticipant(participantId: number): Promise<CapabilityProfileViewModel[]> {
    const httpResult = await this._httpService.apiGet<CapabilityProfileViewModel[]>(`terminalCapability/CapabilityProfilesByParticipant/${participantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalsByTerminalCapability(terminalCapability: string) {

    const httpResult = await this._httpService.apiGet<number>(`terminalCapability/GetTerminalsByTerminalCapability/${terminalCapability}`);
    return httpResult.body;
  }

  public async UpdateParticipantTerminalCapabilities(terminalCapabilities: CapabilityProfileViewModel[]): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPut<CreateResult>(`terminalCapability/UpdateTerminalCapabilities`, terminalCapabilities);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async DeleteParticipantTerminalCapabilitiesByParticipant(id: number): Promise<CreateResult> {
    const httpResult = await this._httpService.apiGet<CreateResult>(`terminalCapability/DeleteTerminalCapabilities/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    } return { message: "An unknown error occured", success: false };
  }

  public async GetTerminalCapabilitiesForParticipant(id: number): Promise<CapabilityProfileViewModel[]> {
    const httpResult = await this._httpService.apiGet<CapabilityProfileViewModel[]>(`terminalCapability/GetTerminalCapabilities/${id}`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }
}
